// Helper: build a UNIQUE luxury image URL for every product.
//
// Each of the 12 boutiques has its own curated pool of 60 real luxury/prestige
// product photos (720 total) retrieved via the ZAI image-search service.
// All 50 products in a boutique get a DIFFERENT luxury image (pool has 60).
//
// Source: src/lib/luxury-images.ts (auto-generated from real web image search).

import type { Product } from "./products-data";
import { luxuryImagesByBoutique } from "./luxury-images";

function hashSeed(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h | 0);
}

function productIndexInBoutique(product: Product): number {
  // Product IDs follow the pattern <boutiqueId>-NNN (e.g. "frais-marche-007")
  const match = product.id.match(/-(\d+)$/);
  if (match) {
    return Math.max(0, parseInt(match[1], 10) - 1);
  }
  return hashSeed(product.id) % 50;
}

/**
 * Build a unique portrait image URL for a product card.
 * Returns a real luxury/prestige product photo from the boutique's pool.
 */
export function productImage(product: Product): string {
  const pool = luxuryImagesByBoutique[product.boutiqueId];
  if (pool && pool.length > 0) {
    const idx = productIndexInBoutique(product) % pool.length;
    return pool[idx];
  }
  const seed = hashSeed(product.id);
  return `https://picsum.photos/seed/${seed}/400/500`;
}

/**
 * Square thumbnail URL for table rows / compact views.
 * Reuses the same luxury image source.
 */
export function productImageSquare(product: Product): string {
  return productImage(product);
}
